export enum ContentType {
  Python = 'python',
  Markdown = 'markdown',
}

export enum NotebookType {
  Python3 = 'python3',
  Python3Edge = 'python3-edge',
  R = 'r',
  Python3CleanSlate = 'python3-cleanslate',
}

export enum NotebookSidebarType {
  Resources = 'resources',
  Help = 'help',
  Secrets = 'secrets',
}

export type Metrics = {
  memory_usage: number;
  max_memory: number;
  min_memory: number;
};

export enum AceLanguage {
  Python = 'python',
  R = 'r',
  Markdown = 'markdown',
}

export enum NotebookState {
  Cancelling = 'cancelling',
  Cancelled = 'cancelled',
  Running = 'running',
  Loading = 'loading',
  Warning = 'warning',
  Session = 'session', // loading the session
  Busy = 'busy',
  Error = 'error',
  Ready = 'ready',
  Alert = 'alert', // new data available
  Success = 'success',
}
